var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBoxOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.75 3a1 1 0 0 0-.863.496l-1.75 3A1 1 0 0 0 3 7v12c0 1.093.907 2 2 2h14c1.093 0 2-.907 2-2V7a1 1 0 0 0-.137-.504l-1.75-3A1.001 1.001 0 0 0 18.25 3H5.75Zm.574 2h11.352l1.166 2H5.158l1.166-2ZM5 9h14v10H5V9Zm4 2v2h6v-2H9Z"
})));
export default SvgBoxOff;